import { render, staticRenderFns } from "./InstrumentModal.vue?vue&type=template&id=8dc64bae&scoped=true&"
import script from "./InstrumentModal.vue?vue&type=script&lang=js&"
export * from "./InstrumentModal.vue?vue&type=script&lang=js&"
import style0 from "./InstrumentModal.vue?vue&type=style&index=0&id=8dc64bae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dc64bae",
  null
  
)

export default component.exports